module.exports = __webpack_public_path__ + "fontawesome-webfont.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = 9